import useShow from '@/hooks/shows/useShowFromURL';
import useShowsBySeedId from '@/react-query/shows/hooks/useShowsBySeedId';

const useRelatedShows = (queryParams) => {
  const { show } = useShow();

  const { id: showId } = show;

  return useShowsBySeedId({
    ...queryParams,
    id: showId
  });
};

export default useRelatedShows;